/* eslint-disable */
export function callBackTempsFort() {
  "use strict";

  $(document).ready(function () {
    const $carouselTempsforts = $(".carousel-tempsforts");

    if ($carouselTempsforts.length > 0) {
      var carouselSlideshow = tns({
        container: ".carousel-tempsforts",
        autoplay: false,
        loop: false,
        center: true,
        items: 1,
        fixedWidth: false,
        mouseDrag: true,
        swipeAngle: false,
        nav: false,
        controlsContainer: ".carousel-navigation",
        nextButton: "#carousel-navigation-next",
        prevButton: "#carousel-navigation-prev",
        responsive: {
          575: {
            items: 2,
            fixedWidth: 1192,
          }
        },
      } );

      if (carouselSlideshow) {

        if($('.carousel-item').length > 1) {
          let seenMonths = {};

          // Création du menu vide de navigation
          $('#tempsforts').find('.zone__title').after('<div class="carousel-tempsforts-thumbnails" id="customize-thumbnails" role="tablist" aria-label="Slides"></div>');

          let totalItem = $('.carousel-item').length;

          // Pour chaque item du carousel
          $('.carousel-item').each(function(index) {
            let dateText = $(this).find('.date').text().trim();
            let dateParts = dateText.split(' ');
            let firstPart = dateParts[0].replace("er", "");
            let monthText = isNaN(firstPart) ? dateParts[0] : dateParts[1];
        
            const monthTextNormalized = monthText
                .toLowerCase()
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "");
          

          $(this).attr("aria-label","Diapositive " + (index + 1) + " sur " + totalItem);

            // Création du mois dans la timeline
            if (!seenMonths[monthTextNormalized]) {
              seenMonths[monthTextNormalized] = true;

              let carouselItemId = $(this).attr('id');

              let thumbnailButtonHtml = "<button class='customize-thumbnails-button' aria-selected='";
              thumbnailButtonHtml += Object.keys(seenMonths).length === 1 ? 'true' : 'false';
              thumbnailButtonHtml += "' role='tab' aria-label="+ monthTextNormalized +" aria-selected='false' aria-controls='"+ carouselItemId +"'>" + monthText + '</button>';
              // Création du bouton de navigation pour le mois dans la navigation
              $('#customize-thumbnails').append(thumbnailButtonHtml);
            }
          });




          // Slider change
          carouselSlideshow.events.on('indexChanged', function(info) {
            let currentSlide = info.displayIndex - 1;
            let currentMonth = $('.carousel-item').eq(currentSlide).attr('id');
            // Mettre à jour le bouton de navigation actif
            $('.customize-thumbnails-button').attr('aria-selected', 'false');
            $('.customize-thumbnails-button[aria-controls="'+currentMonth+'"]').attr('aria-selected', 'true');
          });

        }

        // Gestion des boutons de navigation
        $("#customize-thumbnails")
          .find( "button" ).click(function() {
            let matchingItem = '#'+$(this).attr('aria-controls');
            console.log($(matchingItem));
            carouselSlideshow.goTo($(matchingItem).index());
        });
      }

      // Initialisation du script d'accessibilité
      var sliderA11Y = tinySliderA11Y({
        tns: carouselSlideshow,
        parent: ".zone.highlights",
        parentLabelText: "Article à la une",
        slideLabel: ".list-article-title",
        navLabel: "Diapositive ",
        navCurrentLabel: "(Diapositive courante)",
      } );
    }
  });
}
